import { IRequesterInfo } from '../../../../base/models'
import { ClientProxy } from '../../../../base/proxy/clientProxy'

export class GetIsAuthorizedToCompanyApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'dealer/getIsAuthorizedToCompany',
      requesterInfo,
    })
  }

  public async getIsAuthorizedToCompany(data: string): Promise<any> {
    this.props.url = `${this.props.url}?oModel=${data}`
    return await this.postAsync<any>()
  }
}
